<template>
  <div class="clearfix" v-if="!pageLoad">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="pageLoad" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">

    <!-- Barre de recherche (comme sur la page providers) -->
    <div class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10">
      <div class="position-relative" style="min-width: 220px; max-width: 300px; flex: 1 1 auto;">
        <input
          v-model="searchQuery"
          type="text"
          class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
          placeholder="Rechercher..."
        />
      </div>
      <!--
      <div class="d-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#companyModal"
          style="background-color: #EB9355;"
          @click="initField"
          v-if="current_permissions('create_operator')"
        >
          Ajouter une action
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
      </div>
      -->
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('actions.code') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('actions.action') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('actions.description') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(action) in paginatedActions" :key="action.code">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ action.code }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ action.route === null ? '' : action.route }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ action.description === null ? '' : action.description }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <!-- <div class="dropdown">
                  <button
                    class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="changeStatus(operator.status,operator.code)"
                        ><i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        <span v-if="operator.status==='ACTIVE'">Désactiver</span>
                        <span v-if="operator.status==='INACTIVE'">Activer</span>
                      </a>
                    </li>  
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center" style=""
                        href="javascript:void(0);"                        
                        data-bs-toggle="modal"
                        data-bs-target="#companyModal"
                        @click="showOperator(operator.code)"
                        v-if="current_permissions('edit_operator')"
                        ><i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>                       
                        <span class="">Modifier</span>                        
                      </a>
                    </li>                       
                  </ul>
                </div> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination basée sur useTableFilter (comme la page providers) -->
      <div v-if="filteredTotal>0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p v-if="filteredTotal>10" class="mb-0 text-paragraph">
          {{ $t('actions.showing') }} <span class="fw-bold">{{ pageActions*10 }}</span> {{ $t('actions.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('actions.results') }}
        </p>
        <p v-if="filteredTotal<=10" class="mb-0 text-paragraph">
          {{ $t('actions.showing') }} <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('actions.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('actions.results') }}
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(pageActions-1)>0" class="page-item">
              <a class="page-link" @click="goToPageActions(pageActions-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPagesActions" :key="numPage" class="page-item">
              <a v-if="numPage==pageActions" class="page-link active" href="#">{{ numPage}}</a>
              <a v-else class="page-link" @click="goToPageActions(numPage)">{{ numPage}}</a>
            </li>
            <li v-if="(pageActions+1)<=numPagesActions" class="page-item">
              <a class="page-link" @click="goToPageActions(pageActions+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal Create/Edit Action -->
  <div class="modal fade" id="companyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="save">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ edit == 0 ? $t('actions.addAction') : $t('actions.editAction') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div v-if="success!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('actions.name') }}</label>
                  <div>
                    <input v-model="formValues.name" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('actions.namePlaceholder')" @blur="validate('name')" @keyup="validate('name')" :class="{ 'is-invalid': errorsBis['name'] }" />
                    <span class="invalid-feedback">{{ errorsBis['name']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('actions.mno') }}</label>
                  <div>
                    <input v-model="formValues.mnoName" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('actions.mnoPlaceholder')" @blur="validate('mnoName')" @keyup="validate('mnoName')" :class="{ 'is-invalid': errorsBis['mnoName'] }" />
                    <span class="invalid-feedback">{{ errorsBis['mnoName']}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('actions.status') }}</label>
                  <select name="status" id="status" class="form-select fs-md-15 text-black shadow-none" @change="handleStatusChange" required>
                    <option value="" :selected="selectedStatus==''">{{ $t('actions.select') }}</option>
                    <option value="ACTIVE" :selected="selectedStatus=='ACTIVE'">ACTIVE</option>
                    <option value="INACTIVE" :selected="selectedStatus=='INACTIVE'">INACTIVE</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('actions.paymentMethod') }}</label>
                  <div>
                    <input v-model="formValues.paymentMethod" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('actions.paymentMethodPlaceholder')" @blur="validate('paymentMethod')" @keyup="validate('paymentMethod')" :class="{ 'is-invalid': errorsBis['paymentMethod'] }" />
                    <span class="invalid-feedback">{{ errorsBis['paymentMethod']}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('actions.phoneCode') }}</label>
                  <div>
                    <input v-model="formValues.phoneCode" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('actions.phoneCodePlaceholder')" @blur="validate('phoneCode')" @keyup="validate('phoneCode')" :class="{ 'is-invalid': errorsBis['phoneCode'] }" />
                    <span class="invalid-feedback">{{ errorsBis['phoneCode']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('actions.operationType') }}</label>
                  <select name="operationType" id="operationType" class="form-select fs-md-15 text-black shadow-none" @change="handleOperationTypeChange" required>
                    <option value="" :selected="selectedOperationType==''">{{ $t('actions.select') }}</option>
                    <option value="1" :selected="selectedOperationType=='1'">{{ $t('actions.payin') }}</option>
                    <option value="2" :selected="selectedOperationType=='2'">{{ $t('actions.payout') }}</option>
                    <option value="3" :selected="selectedOperationType=='3'">{{ $t('actions.payinPayout') }}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('actions.provider') }}</label>
                  <select name="provider" id="provider" class="form-select fs-md-15 text-black shadow-none" @change="handleProviderChange" required>
                    <option value="">{{ $t('actions.select') }}</option>
                    <option v-for="provider in providers" :value="provider.code" :key="provider.code" :selected="selectedProvider==provider.code"> {{ provider.name }}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('actions.activationDelay') }}</label>
                  <select name="checkOnlyAfterTimeout" id="checkOnlyAfterTimeout" class="form-select fs-md-15 text-black shadow-none" @change="handleCheckOnlyAfterTimeoutChange" required v-model="selectedCheckOnlyAfterTimeout">
                    <option value="" :selected="selectedPaymentMethod==''">{{ $t('actions.select') }}</option>
                    <option :value="false">{{ $t('actions.inactive') }}</option>
                    <option :value="true">{{ $t('actions.active') }}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('actions.phoneMask') }}</label>
                  <div>
                    <input v-model="formValues.phoneMask" type="number" min="0" max="15" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('actions.phoneMaskPlaceholder')" @blur="validate('phoneMask')" @keyup="validate('phoneMask')" :class="{ 'is-invalid': errorsBis['phoneMask'] }" />
                    <span class="invalid-feedback">{{ errorsBis['phoneMask']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('actions.country') }}</label>
                  <select name="country" id="country" class="form-select fs-md-15 text-black shadow-none" @change="handleCountryChange" required>
                    <option value="">{{ $t('actions.select') }}</option>
                    <option v-for="country in countries" :value="country.countryCode" :key="country.code" :selected="selectedCountry==country.countryCode"> {{ country.name }}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('actions.description') }}</label>
                  <div>
                    <input v-model="formValues.description" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('actions.descriptionPlaceholder')" @blur="validate('description')" @keyup="validate('description')" :class="{ 'is-invalid': errorsBis['description'] }" />
                    <span class="invalid-feedback">{{ errorsBis['description']}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
            <button type="submit" class="btn text-white" style="background-color: #EB9355;" v-if="current_permissions('create_operator', 'edit_operator')">
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i>
              {{ edit == 0 ? $t('actions.save') : $t('actions.edit') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div id="snackbar"></div>
</template>
<script setup  lang="ts">
import {ref, onMounted,reactive,inject } from "vue";
import axios from 'axios';
import router from '../../router/index'
import {showToast,checkSessionValidate} from "../../utils/function";
import {current_permissions} from '../../utils/permission';
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from "vue-i18n";
import * as yup from 'yup';
import { Country,Fee,Operator,Organization,TypeFree, Provider, Actions } from "@/utils/Model";
import { getTypeFee } from "../../utils/services";
import { useTableFilter } from "../../utils/UseTablefilter";

const backApi=inject('back');
const page = ref(1);
const total = ref(0);
const pagesLeft = ref(0);
const currentPage = ref(0);
const numPages = ref(0);
let edit = 0;
let itemCode = '';
let code:string|null='';
const selectedOrganization = ref(code);
const selectedOperator = ref('');
const selectedCountry = ref('');
const selectedTypeFee = ref('');
const selectedMode = ref('');
const btnLoad = ref(true);
const { t } = useI18n();


const selectedStatus = ref('');
const selectedPaymentMethod = ref('');
const selectedOperationType = ref('');
const selectedCheckOnlyAfterTimeout = ref(false);
const selectedProvider = ref('');

let countryCode = ''
let countryName = ''


const loader = ref(false);

let token: string|null = localStorage.getItem('login_token');


const countries =ref(new Array<Country>());
const fees =ref(new Array<Fee>());
const organizations =ref(new Array<Organization>());
const operators =ref(new Array<Operator>());
const providers =ref(new Array<Provider>());
// const typefees =ref([]);
const typefees =ref(new Array<TypeFree>());
let operatorsTemp =new Array<Operator>();
const actions = ref(new Array<Actions>());
let countriesTemp =new Array<Country>();

// Recherche + pagination sur la liste des actions (comme sur la page providers)
const {
  searchQuery,
  paginatedData: paginatedActions,
  filteredTotal,
  page: pageActions,
  numPages: numPagesActions,
  goToPage: goToPageActions,
} = useTableFilter(
  actions,
  [
    (t: any) => t.code,
    (t: any) => t.route,
    (t: any) => t.description,
  ],
  15
);

  const errors = ref('');  
  const errorId = ref('');  
  const success = ref('');
  const errorsBis = {'name':'','valeur':'', 'mnoName':'', 'description':''};
  const pageLoad = ref(false);

  const formValues = reactive({    
    valeur: "",  
    name: "",

    mnoName: "",
    description: "",
    phoneCode: "",
    phoneMask: 0,
    paymentMethod: ""
    // heckOnlyAfterTimeout :false

  });

  
  const schema = yup.object({    
      // valeur: yup.number().required('La valeur est requise'),  
      name: yup.string().required('Le nom de l\'operateur  est requis'),   

      mnoName: yup.string().required('Le nom du mno est requis'),   
      description: yup.string().required('Le nom du mno est requis'),   
      phoneCode: yup.string().required('L\'indice telephonique est requis'),   
      phoneMask: yup.string().required('Le masque telephonique est requis'),   
      paymentMethod: yup.string().required('La methode de paiement est requise'),   
     
  });

const initField = () =>{
  formValues.name=  ''; 
  formValues.mnoName=  ""; 
  formValues.description=  ""; 
  formValues.phoneCode=  ""; 
  formValues.phoneMask=  0; 
  formValues.paymentMethod=  ""; 
  // selectedOrganization.value = code; 
  // selectedOperator.value = '';  
  // selectedTypeFee.value = '';  
  // selectedMode.value = '';  
  // selectedCountry.value = '';  
  itemCode = '';
  edit=0;
  // selectedPaymentMethod.value = '',
  selectedCountry.value = '' ,
  selectedOperationType.value = '',
  selectedProvider.value = '',
  selectedCheckOnlyAfterTimeout.value = false ,
  selectedStatus.value = '';
  errorId.value=''
  errors.value=''
}

  function handleOrganizationChange(event) {
      selectedOrganization.value = event.target.value;
    }

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleTypeFeeChange(event) {
  selectedTypeFee.value = event.target.value;
}

function handleCheckOnlyAfterTimeoutChange(event) {
  selectedCheckOnlyAfterTimeout.value = event.target.value;
}

// function handleCheckOnlyAfterTimeoutChange(event) {
//   selectedCheckOnlyAfterTimeout.value = event.target.value === "1";
// }


function handleModeChange(event) {
  selectedMode.value = event.target.value;
}

function handleStatusChange(event) {
  selectedStatus.value = event.target.value;
}

function handlePaymentMethodChange(event) {
  selectedPaymentMethod.value = event.target.value;
}

function handleOperationTypeChange(event) {
  selectedOperationType.value = event.target.value;
}

function handleProviderChange(event) {
  selectedProvider.value = event.target.value;
}

function handleCountryChange(event) {
  // selectedCountry.value = event.target.value;
  var i = 0;
  while(i<countriesTemp.length){    
      if(countriesTemp[i].countryCode == event.target.value){         
          selectedCountry.value=countriesTemp[i].code;
          countryCode = selectedCountry.value=countriesTemp[i].countryCode;
          countryName = selectedCountry.value=countriesTemp[i].name;
      }      
      i++;
  }
  // operators
  var j = 0;
  var operatorArr = new Array<Operator>();
  while(j<operatorsTemp.length){    
      if(operatorsTemp[j].countryCode == event.target.value){         
          operatorArr.push(operatorsTemp[j]);
      }      
      j++;
  }
   operators.value = operatorArr;
}

function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();  
        day = day<10?'0'+day:day;      
        return day+'/'+month+'/'+year;
        
    }
}

const getFees = (arg=1) =>{
    // +arg    
    axios.get(backApi+'/secure/fees/?organization='+code,{    
      headers: {
            
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {        
        fees.value = response.data;  //.data.fees            
        
        // total.value=parseInt(response.data.pagination.total);
        // page.value=parseInt(response.data.pagination.page);
        // pagesLeft.value=parseInt(response.data.pagination.pagesLeft);
        // currentPage.value=parseInt(response.data.pagination.currentPage);
        // numPages.value=parseInt(response.data.pagination.numPages);

        total.value=10;
        page.value=1;
        pagesLeft.value=0;
        currentPage.value=1;
        numPages.value=1;
        
        // alert(total.value)
    }).catch((error) => {
          if( error.response){              
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
}

const getOrganizations = () =>{

axios.get(backApi+'/secure/organizations/',{  
  headers: {
       
        Authorization: `Bearer ${token}`
  } 
})
.then((response) => {
    // users.value = response.data;
    organizations.value = response.data;  //.data.users          
    console.log(response.data);
    
    
}).catch((error) => {
      if( error.response){
          console.log(error.response.data); // => the response payload 
          if(error.response.status === 401){
            router.push('/')
            //window.location.href = '/';
            //router.push('/');
          }   
          
      }
});
//  loader.value=true;
}

// Récupère une page depuis l'API (forme { data, pagination })
const fetchProvidersPage = (targetPage: number) => {
  const url = `${backApi}/secure/providers/?page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

// Charge TOUTES les pages de providers (boucle sur pagination.numPages)
const getProviders = async () => {
  try {
    const first = await fetchProvidersPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchProvidersPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    providers.value = collected;
  } catch (error: any) {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const getTypeFees = () =>{

axios.get(backApi+'/secure/typefees/',{  
  headers: {
       
        Authorization: `Bearer ${token}`
  } 
})
.then((response) => {
    // users.value = response.data;
    typefees.value = response.data;  //.data.users          
    console.log(response.data);
    
    
}).catch((error) => {
      if( error.response){
          console.log(error.response.data); // => the response payload 
          if(error.response.status === 401){
            router.push('/')
            //window.location.href = '/';
            //router.push('/');
          }   
          
      }
});
//  loader.value=true;
}

const getCountries = () =>{

axios.get(backApi+'/secure/countries/',{  
  headers: {
       
        Authorization: `Bearer ${token}`
  } 
})
.then((response) => {
     countriesTemp = response.data;
    countries.value = response.data;  //.data.users          
    console.log(response.data);
    
    
}).catch((error) => {
      if( error.response){
          console.log(error.response.data); // => the response payload 
          if(error.response.status === 401){
            router.push('/')
            //window.location.href = '/';
            //router.push('/');
          }   
          
      }
});
//  loader.value=true;
}

const getOperators = () =>{

axios.get(backApi+'/secure/operators/',{  
headers: {
   
    Authorization: `Bearer ${token}`
} 
})
.then((response) => {
operatorsTemp = response.data;  //.data.users          
console.log("OP___",response.data);

}).catch((error) => {
  if( error.response){
      console.log(error.response.data); // => the response payload 
      if(error.response.status === 401){
        router.push('/')        
      }   
      
  }
});

}

// Récupère une page depuis l'API (forme { data, pagination })
const fetchActionsPage = (targetPage: number) => {
  const url = `${backApi}/secure/actions/?page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

// Charge TOUTES les pages d'actions (boucle sur pagination.numPages)
const getActions = async () => {
  try {
    const first = await fetchActionsPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchActionsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    actions.value = collected;
  } catch (error: any) {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const changeStatus =(status,code)=>{
 // alert(code)
  axios.put(`${backApi}/secure/operators/${code}/status`,{
          code: code,
          status:  (status=='ACTIVE')?'INACTIVE':'ACTIVE'
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
      }       
      }).then((response) => {        
        router.go();        
        
    }).catch((error) => {
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
}


const showOperator = (code) =>{
    // +arg
     axios.get(backApi+'/secure/operators/'+code+'/show',{    
      headers: {
            
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {        

        formValues.name = response.data.name;
        formValues.mnoName = response.data.mnoName;
        formValues.paymentMethod = response.data.paymentMethod;
        formValues.phoneCode = response.data.phoneCode;
        formValues.description = response.data.description;
        formValues.phoneMask = response.data.phoneMask;

        selectedStatus.value = response.data.status;
        selectedOperationType.value = response.data.operationType;
        selectedProvider.value = response.data.provider.code;
        selectedCountry.value = response.data.countryCode;
        selectedCheckOnlyAfterTimeout.value = response.data.checkOnlyAfterTimeout;

        itemCode = response.data.code;


        edit=1;        
        // console.log(response.data);
    }).catch((error) => {
          if( error.response){              
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                console.log(error.response);
              }   
              
          }
  });
}

const save =()=>{
  if (edit==0){
    storeOperator()
  }else{
    updateProvidor()
  }
  
}

const storeOperator =()=>{
try {  
  schema.validateSync(formValues);
  // alert(formValues)
  axios.post(`${backApi}/secure/operators/new`,{          
          name:formValues.name,
          mnoName: formValues.mnoName ,
          status: selectedStatus.value ,
          paymentMethod: formValues.paymentMethod,
          countryCode: countryCode ,
          countryName: countryName ,
          phoneCode: formValues.phoneCode ,
          operationType: selectedOperationType.value ,
          description: formValues.description ,
          phoneMask: formValues.phoneMask ,
          provider: selectedProvider.value ,
          checkOnlyAfterTimeout: selectedCheckOnlyAfterTimeout.value
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => {  
        if(response.status === 200){      
          showToast("Operateur "+formValues.name.toLowerCase()+" enregistré avec succès","green");
          initField();   
          // router.go();  
        }      
        
    }).catch((error) => {
      // alert(error.response.data.errorId);
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              } 
              
          }
  });
} catch (error) {
        // console.log(error);        
         errors.value="une erreur inattendue est apparue"
         
              
}

// name:name.value,
// email:email.value,
// contact:contact.value,
// description:description.value
}

const updateProvidor =()=>{
  btnLoad.value=false;
  // console.log("PROVIDER___",selectedProvider.value)
  // console.log("DELAIS___",selectedCheckOnlyAfterTimeout.value)
try {  
  schema.validateSync(formValues);
  // alert(formValues)
  axios.put(`${backApi}/secure/operators/${itemCode}/edit`,{          
          name:formValues.name,
          description:formValues.description,

          mnoName: formValues.mnoName ,
          status: selectedStatus.value ,
          paymentMethod: formValues.paymentMethod,
          countryCode: countryCode ,
          countryName: countryName ,
          phoneCode: formValues.phoneCode ,
          operationType: selectedOperationType.value ,
          phoneMask: formValues.phoneMask ,
          provider: selectedProvider.value ,
          checkOnlyAfterTimeout: selectedCheckOnlyAfterTimeout.value,
        
          code:itemCode,     
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => {            
        btnLoad.value=true;
        if(response.status === 200){   
          showToast("Modification effectuée avec succès","green");            
          router.go();  
        }      
        
    }).catch((error) => {
      btnLoad.value=true;
      // alert(error.response.data.errorId);
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              } 
              
          }
  });
} catch (error) {
        // console.log(error);        
         errors.value="une erreur inattendue est apparue"
         btnLoad.value=true;       
              
}

}

function validate(field) {
      schema
        .validateAt(field, formValues)
        .then(() => {
          errorsBis[field] = "";
        })
        .catch(err => {
          errorsBis[field] = err.message;          
        });
        errors.value=''
}


onMounted(async () => { 
  checkSessionValidate(1)
   const route = useRoute();
   code = route.params.id;
   getFees();
   getOperators();
   await getProviders();
   await getActions();
   getOrganizations();
   getTypeFees();
   getCountries();
 
   setTimeout(function () {
    pageLoad.value=true; 
         },1000)
});
</script>